import { BaseDictionarySingleton } from '../entities.js';
import server from 'server2';

import { dictionaryExporter } from '../helpers';

class OfficeRegionsDictionary extends BaseDictionarySingleton {
	update () {
		return server.any.api.get([
			'offices',
			'getAllRegions',
		]).then(response => {
			const { responseJSON: { Data }} = response;

			this._data(Data);

			return Data;
		});
	}
}

export default dictionaryExporter(OfficeRegionsDictionary);
